import { create } from 'zustand'
import Cookies from 'js-cookie'

const LOGGED_IN_AT_KEY = 'logged_in_at'
export const useIsLoggedIn = create<boolean>(() => false)

const authService = {
    isLoggedIn: () => authService.getLoggedInAt() !== undefined,
    getLoggedInAt: () => {
        const isLoggedIn = Cookies.get(LOGGED_IN_AT_KEY)
        useIsLoggedIn.setState(isLoggedIn !== undefined)
        return isLoggedIn
    },
    setLoggedIn: () => {
        Cookies.set(LOGGED_IN_AT_KEY, `${Date.now()}`)
        useIsLoggedIn.setState(true)
    },
    removeIsLoggedIn: () => {
        Cookies.remove(LOGGED_IN_AT_KEY)
        useIsLoggedIn.setState(false)
    }
}

export default authService